export const LOTTO_CONSTANTS = {
  EXPIRED_ERROR_MESSAGE:
    'Some bets in your Bet Slip have expired! Please remove them.',
  SAFETY_ITERATION_LIMIT: 5000,
  DEFAULT_STAKE: 10,
  MIN_STAKE: 1,
  MAX_STAKE: 10_000_000,
  CART_SUCCESS_DISMISS_DELAY: 2000,
  ANIMATION_DURATION: 350,
  SUBMISSION_DEBOUNCE_MS: 300,
  COUNTDOWN_INTERVAL_MS: 1000,
  SCROLL_DEBOUNCE_MS: 100,
  LOAD_COMPLETE_DELAY_MS: 150,
  CENTS_MULTIPLIER: 100,
};

export const MAX_BALLS_BY_MARKET = {
  1: 25,
  2: 14,
  3: 9,
  4: 8,
  5: 8,
  6: 9,
  7: 9,
  8: 10,
  9: 11,
  10: 12,
  11: 13,
  12: 14,
};

export const CHAT_COMMANDS = [
  {
    command: '/dream',
    description: 'Interpret a dream and get lucky numbers',
    placeholder: 'What did you dream about?',
    color: '#6B21A8',
  },
];

export const KNOWN_COMMANDS = new Set(CHAT_COMMANDS.map((c) => c.command));

export const SLASH_COMMAND_RE = /^(\/\w+)(\s[\s\S]*)?$/;

export const LOTTERY_TYPE = {
  REGULAR: 'REGULAR',
  INSTANT: 'INSTANT',
};

export const TAB_VALUE = {
  POPULAR: 'POPULAR',
  REGULAR: LOTTERY_TYPE.REGULAR,
  INSTANT: LOTTERY_TYPE.INSTANT,
};

export const BALL_COLORS = {
  NORMAL: '#A9499D',
  BONUS: '#6B21A8',
  BONUS_BORDER: '#6B21A8',
  TEXT: '#FCFBFB',
};

export const PROGRESS_BAR_COLORS = {
  VALID: '#2C6B2F',
  INVALID: '#656565',
};

export const BET_STATUS_COLORS = {
  won: { color: '#2C6B2F', bg: '#E4F8E4' },
  accepted: { color: '#2C6B2F', bg: '#E4F8E4' },
  registered: { color: '#2C6B2F', bg: '#E4F8E4' },
  partially_won: { color: '#2C6B2F', bg: '#E4F8E4' },
  scheduled: { color: '#8D56F3', bg: '#F4F0FC' },
  void: { color: '#8D56F3', bg: '#F4F0FC' },
  pending: { color: '#8D56F3', bg: '#F4F0FC' },
  lost: { color: '#C45420', bg: '#FDF1EA' },
  canceled: { color: '#515151', bg: '#F3F3F3' },
  cancelled: { color: '#515151', bg: '#F3F3F3' },
  declined: { color: '#515151', bg: '#F3F3F3' },
};
